var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 17 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.46967 0.531193C0.762563 0.2383 1.23744 0.2383 1.53033 0.531193L6.46972 5.47059C6.76016 5.76103 7.23984 5.76103 7.53028 5.47059L12.4697 0.531193C12.7626 0.2383 13.2374 0.2383 13.5303 0.531193C13.8232 0.824087 13.8232 1.29896 13.5303 1.59185L8.59094 6.53125C7.71471 7.40747 6.28529 7.40747 5.40906 6.53125L0.46967 1.59185C0.176777 1.29896 0.176777 0.824087 0.46967 0.531193Z",
    fill: "#14477D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.e0b57d9ecf9c0ec0c1312b8952e89201.svg";
export { ForwardRef as ReactComponent };